import { Component, OnInit } from '@angular/core';
import { AssignJeevesDefaultsComponent, JeevesDeliveryAddressesService } from 'gung-standard-jeeves';
import {
  CustomerContactService,
  SelectedCustomerService,
  Customer,
  CustomerService,
  GungFlowService,
  AuthService,
  CartService,
  AvailabilityService,
  GungFlow,
  CustomerContact,
  CartRow
} from 'gung-standard';
import { DateUtilService, gungGetPropertyOfObject } from 'gung-common';
import { merge } from 'lodash-es';
import {
  CheckoutSettingsGroup,
  HlDisplayPortalFeaturesService
} from '../../../services/hl-display-portal-features.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-hl-assign-defaults',
  templateUrl: './hl-assign-defaults.component.html',
  styleUrls: ['./hl-assign-defaults.component.css'],
  standalone: false
})
export class HlAssignDefaultsComponent extends AssignJeevesDefaultsComponent implements OnInit {
  checkoutSettingsGroup: CheckoutSettingsGroup;
  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected customerContactService: CustomerContactService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService,
    protected hlDisplayPortalFeaturesService: HlDisplayPortalFeaturesService
  ) {
    super(
      selectedCustomerService,
      customerService,
      customerContactService,
      gungFlowService,
      authService,
      cartService,
      availabilityService,
      dateUtilService,
      jeevesDeliveryAddressesService
    );
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.hlDisplayPortalFeaturesService
      .getPortalFeatureGroup('orderCheckoutSettingsGroup')
      .pipe(first())
      .subscribe(group => {
        this.checkoutSettingsGroup = group as CheckoutSettingsGroup;
      });
  }

  protected setValues(
    customer: Customer,
    flow: GungFlow,
    user,
    customerContacts: CustomerContact[],
    billingCustomer?: Customer,
    cartRows?: CartRow[]
  ) {
    super.setValues(customer, flow, user, customerContacts, billingCustomer);

    // only prepopulate if not sales personel
    if (!user.roles.includes('ADMIN') && !user.roles.includes('SALES')) {
      this.checkout.extra.oh.kundref2 = user.email;
      this.checkout.extra._msFlowOrderConfirmEmail = user.email;
    }

    if (!this.checkout.extra.kus) {
      this.checkout.extra.kus = {};
    }
    this.checkout.extra.kus.q_hl_emailtt = customer.extra.kus.q_hl_emailtt || '';

    if (this.checkoutSettingsGroup.useCustomerDefaultEmailForConfirmation) {
      this.checkout.extra._msFlowOrderConfirmEmail = customer.extra.kus.q_hl_default_email || '';
    }
    const fieldValue = gungGetPropertyOfObject(this.checkoutSettingsGroup.customerOrderNumberAutoFillField, customer);
    if (fieldValue || this.checkoutSettingsGroup.customerOrderNumberPrefix) {
      this.checkout.extra.oh.kundbestnr = `${this.checkoutSettingsGroup.customerOrderNumberPrefix ?? ''}${fieldValue ?? ''}`;
    }

    if (user.extra.orderParams) {
      merge(this.checkout.extra, user.extra.orderParams);
    }

    if (user.roles.includes('ADMIN') || user.roles.includes('SALES')) {
      this.checkout.extra.kus.q_hl_default_email = customer.extra.kus.q_hl_default_email || '';
      this.checkout.extra.kus.q_hl_mail_invoicecc = customer.extra.kus.q_hl_mail_invoicecc || '';
    }

    if (user.roles.includes('CUSTOMER_SERVICE')) {
      this.checkout.extra.oh = {
        ...this.checkout.extra.oh,
        kundbetalarenr: customer.extra.kus.kundbetalarenr || ''
      };
      if (customer.extra.kus?.q_hl_chargepalletrimcost) {
        this.checkout.extra.oh.q_hl_chargepalletrimcost = customer.extra.kus.q_hl_chargepalletrimcost;
      }
    }
  }
}
